import CRUD from './crud'

export default new CRUD('tournament-schedule-items')
